import {useMemo} from "react";
import {Box} from "@mui/material";
import {alpha} from "@mui/material/styles";
import {DataGrid, type DataGridProps} from "@mui/x-data-grid";
import {deDE, enUS} from "@mui/x-data-grid/locales";
import {useTranslation} from "react-i18next";

const AdminDataGrid = (props: DataGridProps) => {
    const {i18n} = useTranslation();
    const localeText = useMemo(
        () => (i18n.language.startsWith("de") ? deDE : enUS).components.MuiDataGrid.defaultProps.localeText,
        [i18n.language],
    );

    return (
        <Box
            sx={(theme) => ({
                border: "1px solid",
                borderColor: theme.palette.divider,
                borderRadius: 3,
                overflow: "hidden",
                bgcolor: theme.palette.background.paper,
                ".MuiDataGrid-root": {
                    border: 0,
                    backgroundColor: "transparent",
                    color: theme.palette.text.primary,
                },
                ".MuiDataGrid-columnHeaders": {
                    backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === "light" ? 0.05 : 0.12),
                    borderBottom: "1px solid",
                    borderColor: theme.palette.divider,
                },
                ".MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                },
                ".MuiDataGrid-cell": {
                    borderColor: theme.palette.divider,
                    alignItems: "center",
                },
                ".MuiDataGrid-row:hover": {
                    backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === "light" ? 0.03 : 0.08),
                },
                ".MuiDataGrid-footerContainer": {
                    borderTop: "1px solid",
                    borderColor: theme.palette.divider,
                },
            })}
        >
            <DataGrid
                disableRowSelectionOnClick
                rowHeight={72}
                pageSizeOptions={[5, 10, 25]}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                            page: 0,
                        },
                    },
                    ...props.initialState,
                }}
                localeText={{...localeText, ...props.localeText}}
                {...props}
            />
        </Box>
    );
};

export default AdminDataGrid;
